import { RegisteredComponent } from "@builder.io/sdk-react";
import {
  THEME_FIELD,
  SIZE_FIELD,
  DLD_FIELD,
  DLT_FIELD,
  HREF_FIELD,
} from "@/libs/builder/commonFields";

export const buttonBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Core:Button",
  override: true,
  noWrap: true,
  inputs: [
    {
      name: "text",
      type: "string",
      required: true,
      localized: true,
      defaultValue: {
        "@type": "@builder.io/core:LocalizedValue",
        Default: "Button text",
      },
    },
    HREF_FIELD,
    DLD_FIELD,
    DLT_FIELD,
    {
      name: "variant",
      type: "enum",
      defaultValue: "primary",
      localized: false,
      enum: [
        {
          label: "primary",
          value: "primary",
        },
        {
          label: "secondary",
          value: "secondary",
        },
        {
          label: "tertiary",
          value: "tertiary",
        },
      ],
    },
    {
      name: "iconPrimary",
      friendlyName: "icon",
      type: "enum",
      defaultValue: "none",
      localized: false,
      enum: [
        { label: "None", value: "none" },
        { label: "Arrow right", value: "arrowRight" },
      ],
      showIf: (options) =>
        options?.get("variant") === "primary" ||
        options?.get("variant") === "secondary",
    },
    {
      name: "icon",
      type: "enum",
      defaultValue: "arrowRight",
      localized: false,
      enum: [
        {
          label: "Arrow right",
          value: "arrowRight",
        },
        {
          label: "Arrow left",
          value: "arrowLeft",
        },
        {
          label: "Arrow up",
          value: "arrowUp",
        },
        {
          label: "Arrow down",
          value: "arrowDown",
        },
        {
          label: "Circled arrow right",
          value: "circleArrowRight",
        },
        {
          label: "Circled arrow left",
          value: "circleArrowLeft",
        },
        {
          label: "Circled arrow up",
          value: "circleArrowUp",
        },
        {
          label: "Circled arrow down",
          value: "circleArrowDown",
        },
        {
          label: "Solid arrow left",
          value: "solidArrowLeft",
        },
      ],
      showIf: (options) => options?.get("variant") === "tertiary",
    },
    {
      name: "iconPosition",
      friendlyName: "Icon position",
      type: "enum",
      defaultValue: "right",
      localized: false,
      enum: [
        {
          label: "left",
          value: "left",
        },
        {
          label: "right",
          value: "right",
        },
      ],
      showIf: (options) => options?.get("variant") === "tertiary",
    },
    SIZE_FIELD,
    THEME_FIELD,
    {
      name: "disabled",
      type: "boolean",
      localized: false,
      required: false,
    },
    {
      name: "loading",
      type: "boolean",
      localized: false,
      required: false,
    },
    {
      name: "trackingMetric",
      type: "text",
    },
    {
      name: "renderLeftBorder",
      type: "boolean",
      friendlyName: "Render left border",
      localized: false,
      required: false,
      showIf: (options) => options?.get("variant") === "tertiary",
    },
  ],
};
